import { Hit } from '../../globals'

const CONTENT_TYPES = {
  Document: 'application/pdf'
}

type KnowledgeHitsComponentProps = {
  topic: string
  hits: Hit[]
  hideContent: boolean
}

const customizeLink = (link: string) => {
  const url = new URL(link)
  const pathArray = (url.pathname || '').split('/')
  return `${url.hostname}${pathArray.join(' › ')}`
}

const getRelativeLink = (
  link: string,
  contentType: string,
  relative: string
) => {
  if (contentType === CONTENT_TYPES.Document && relative) {
    return `${link}#page=${relative}`
  } else {
    return link
  }
}

const getContentHint = (contentType: string, relative: string) => {
  if (contentType === CONTENT_TYPES.Document && relative) {
    return <p className="contentHint">Page {relative}</p>
  } else {
    return null
  }
}

const KnowledgeHitsComponent = ({
  topic,
  hits,
  hideContent = false
}: Partial<KnowledgeHitsComponentProps>) => {
  if (!hits || !hits.length) return null

  return (
    <div className="search-content">
      <p className="search-title">Search results in &apos;{topic}&apos;</p>
      {hits.map(({ link, title, highlighted, contentType, relative }) => {
        return (
          <div className="search-content-item" key={link}>
            <a
              className="linkComponent"
              target="_blank"
              href={getRelativeLink(link, contentType, relative)}
              rel="noreferrer"
            >
              <div className="topLinkContainer">
                <span className="link">{customizeLink(link)}</span>
                <ContentTypeIcon contentType={contentType} />
              </div>
              <h4
                className="title"
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              />
            </a>
            {!hideContent && (
              <p
                className="content"
                dangerouslySetInnerHTML={{
                  __html: `${highlighted.trim().split('\n').join('... ')}`
                }}
              />
            )}
            {getContentHint(contentType, relative)}
          </div>
        )
      })}
    </div>
  )
}

type ContentTypeIconProps = { contentType: string }
const ContentTypeIcon = ({ contentType }: ContentTypeIconProps) => {
  const contentTypeIndex = Object.values(contentType).indexOf(contentType)
  if (contentTypeIndex !== -1)
    return (
      <span className="contentTypeIcon">
        {Object.keys(contentType)[contentTypeIndex]}
      </span>
    )
  else return null
}

export default KnowledgeHitsComponent
